import React, { useState } from 'react'
import Flex from 'components/Flex'
import { Avatar,Divider,Modal} from 'antd'
import corporateLogo from 'assets/images/Frame 5608.png'
import Visibility from 'components/icons/Visibility'
import {
  Name,
  Address,
  NameAdd,
  ViewIcon,
  ModalImg
} from 'modules/Resume/Style/style'

const Documents = ({studentDetails}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [url, setUrl] = useState('')
  const showModal = (event, param) => {
    if(param.type === 'pdf'){
      const newWindow = window.open(param.url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
    else{
      setUrl(param.url)
      setIsModalOpen(true);
    }

  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
     
     {studentDetails?.studentPersonalProfile?.addressProof.map((item, index) => (
          <>
            <Flex centerVertically>
              <Avatar shape="square" size={42} src={corporateLogo} />
              <NameAdd column flexStart>
                <Address>{item?.name}</Address>
                <Name>{item?.size}MB</Name>
              </NameAdd>
              <ViewIcon>
                <Flex>
                  <Avatar onClick={event => showModal(event, item)}  src={<Visibility />} />
                </Flex>
              </ViewIcon>
            </Flex>
            <Divider />
          </>
        )
      )}
      {studentDetails?.studentPersonalProfile?.idProof.map((item, index) => (
          <>
            <Flex centerVertically>
              <Avatar shape="square" size={42} src={corporateLogo} />
              <NameAdd column flexStart>
                <Address>{item?.name}</Address>
                <Name>{item?.size}MB</Name>
              </NameAdd>
              <ViewIcon>
                <Flex>
                  <Avatar onClick={event => showModal(event, item)} src={<Visibility />} />
                </Flex>
              </ViewIcon>
            </Flex>
            <Divider />
          </>
        )
      )}
      <Modal title="View Document" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
       <ModalImg src={url}/>
      </Modal>
    </>
  )
}
export default Documents
